import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import 'whatwg-fetch';
import './initialize';
import { createRoot } from 'react-dom/client';
import App from './App';
document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('app-container');
    const root = createRoot(container);
    root.render(_jsx(App, {}));
});
